import {Client} from "@/endpoints/rutsolve/gql/resolvers/client"
import {
    PaymentRedirectInput,
    PaymentRedirectQueryVariables,
    PaymentRedirectDocument
} from "@/endpoints/rutsolve/gql/generated/graphql"

export class Payment extends Client {
    constructor() {
        super()
    }

    public async redirect(input: PaymentRedirectInput): Promise<string> {
        try {
            const variables: PaymentRedirectQueryVariables = {
                input: input
            }
            const response = await this.client.request(PaymentRedirectDocument, variables)
            return response.paymentRedirect
        } catch (error) {
            this.handleError(error)
        }
    }
}
